module.exports = __webpack_public_path__ + "static/media/p3-count.e8e221a8.csv";